export default {
  UPDATING: 'ADMIN_VIEW_MARKET_GROUPS_EDITOR_UPDATING',
  UPDATED: 'ADMIN_VIEW_MARKET_GROUPS_EDITOR_UPDATED',
};
